<div class="home">
  <!-- Web-only "get the app" banner. Hidden inside the native app. -->
  <nbd-install-banner />

  <div class="home__lang safe-pt">
    <nbd-language-selector />
  </div>

  <main class="home__content safe-pb">
    <img class="home__logo" [src]="logoUrl" alt="RealGuest">
    <h1 class="home__title">{{ 'home.title' | translate }}</h1>
    <p class="home__tagline">{{ 'home.tagline' | translate }}</p>

    <p class="home__explain">{{ 'home.scanExplain' | translate }}</p>

    <button matButton="filled" class="home__scan" (click)="scan()">
      <mat-icon>qr_code_scanner</mat-icon>
      {{ 'home.scanButton' | translate }}
    </button>

    <button matButton="outlined" class="home__enter-code" (click)="enterCode()">
      <mat-icon>keyboard</mat-icon>
      {{ 'home.enterCode' | translate }}
    </button>

    @if (savedEvent) {
      <button matButton="outlined" class="home__resume" (click)="resume()">
        <mat-icon>replay</mat-icon>
        {{ 'home.resume' | translate }}
      </button>
    }

    <a matButton="text" class="home__website" [href]="websiteUrl" target="_blank" rel="noopener">
      {{ 'home.website' | translate }}
    </a>

    <!-- Required by App Store 5.1.1(i) and Play's User Data policy to be reachable
         INSIDE the app. Kept on Home, before any event code is entered, so it is
         findable by a reviewer who never gets past this screen. -->
    <a matButton="text" class="home__privacy" [href]="privacyUrl" target="_blank" rel="noopener">
      {{ 'common.privacyPolicy' | translate }}
    </a>

    <span class="home__version">v{{ appVersion }}</span>
  </main>
</div>
